import { useState } from "react";
import webSocketService from "../services/WebSocketService";

const useUserData = (userId = "") => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [referredData, setReferredData] = useState(null);
  const [transactionsData, setTransactionsData] = useState([]);
  const [transfersData, setTransfersData] = useState([]);
  const [hideDocNumber, setHideDocNumber] = useState(true);
  const [referrer, setReferrer] = useState(null);
  const [showCreditModal, setShowCreditModal] = useState(false);
  const [showChargeModal, setShowChargeModal] = useState(false);
  const [showChargeModalConfirm, setShowChargeModalConfirm] = useState(false);
  const [showChangeGroupModal, setShowChangeGroupModal] = useState(false);
  const [limitsData, setLimitsData] = useState([]);
  const [tokens, setTokens] = useState([]);
  const [tokensData, setTokensData] = useState([]);
  const [prompts, setPromptList] = useState([]);

  const limits = userData?.restrictions?.limits;

  const onShowMore = () => {
    const currentLength = tokensData?.length;

    setTokensData((prev) => [
      ...prev,
      ...tokens?.slice(currentLength, currentLength + 10),
    ]);
  };

  const onShowLess = () => setTokensData(tokens?.slice(0, 5));

  const getUserData = async () => {
    setTimeout(async () => {
      const user = await webSocketService.sendMessage("getUser", "c", {
        userId,
      });

      if (user === "contact not found") {
        return;
      }
      const referred = await webSocketService.sendMessage("findUsers", "c", {
        referral: { alias: user?.referral?.codes[0]?.code },
      });
      const referredFriendly = user?.referral?.codes[1]?.code
        ? await webSocketService.sendMessage("findUsers", "c", {
            referral: { alias: user?.referral?.codes[1]?.code },
          })
        : [];

      const referrerData = await webSocketService.sendMessage("getUser", "c", {
        userId: user?.referral?.referrer,
      });

      const transactions = await webSocketService.sendMessage(
        "getTransactions",
        "c",
        {
          userId,
        },
      );

      const promptList = await webSocketService.sendMessage("promptList", "c", {
        userId,
        custodial: "crypto",
      });

      const finalizedTransactions = transactions.filter(
        (el) => el.status === "finalized",
      );

      const transfers = await webSocketService.sendMessage(
        "getTransfers",
        "c",
        {
          userId,
        },
      );
      const finalizedTransfers = transfers?.filter(
        (el) => el.status === "finalized",
      );

      const restrictionSchemes = await webSocketService.sendMessage(
        "getRestrictionSchemes",
        "c",
      );
      const parsedSchemes = Object.values(restrictionSchemes)?.map((el) => ({
        value: el?.name,
        label: el?.name,
      }));

      const tokens = await webSocketService.sendMessage("getTokens", "c", {
        userId,
      });
      setTokens(tokens);
      setTokensData(tokens?.slice(0, 5));
      setLimitsData(parsedSchemes);
      setReferrer(referrerData);
      setTransactionsData(finalizedTransactions);
      setTransfersData(finalizedTransfers);
      setReferredData([...referred, ...referredFriendly]);
      setUserData(user);
      setPromptList(promptList);
      setLoading(false);
    }, 2000);
  };

  return {
    getUserData,
    loading,
    referredData,
    transactionsData,
    hideDocNumber,
    referrer,
    showCreditModal,
    userData,
    setShowCreditModal,
    setHideDocNumber,
    transfersData,
    setShowChangeGroupModal,
    showChangeGroupModal,
    limitsData,
    limits,
    tokensData,
    onShowMore,
    onShowLess,
    prompts,
    showChargeModal,
    setShowChargeModal,
    showChargeModalConfirm,
    setShowChargeModalConfirm,
  };
};
export default useUserData;
